<script lang="ts">
    let {
        type = "success",
        visible = false,
        message = "",
        duration = 2500,
    } = $props();

    import { getMobileOS } from "@utils/common";

    $effect(() => {
        if (visible) {
            const timer = setTimeout(() => {
                visible = false;
            }, duration);

            // Limpieza del efecto
            return () => clearTimeout(timer);
        }
    });
</script>

{#if visible}
    <div
        class="toast --{type} {getMobileOS()}"
        role="status"
        aria-live="polite"
    >
        <span>{message}</span>
    </div>
{/if}

<style lang="scss">
    @use "./styles/index.scss";
</style>
